<div class="container">
  <form *transloco="let t" [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
    <div class="row">
      <div class="col">
        <app-password-field
          [formControl]="resetPasswordForm.controls.password"
          [maxLength]="255"
          [label]="t('auth.reset.InputLabel')">
        </app-password-field>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <app-altcha formControlName="captcha"/>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="!resetPasswordForm.valid">
            {{ t('auth.reset.BtnReset') }}
          </button>
        </div>
      </div>
    </div>
  </form>

</div>
